import { render, staticRenderFns } from "./UserRankingTableHeader.vue?vue&type=template&id=55445976&scoped=true&"
import script from "./UserRankingTableHeader.vue?vue&type=script&lang=js&"
export * from "./UserRankingTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserRankingTableHeader.vue?vue&type=style&index=0&id=55445976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55445976",
  null
  
)

export default component.exports